import { render, staticRenderFns } from "./customer_monthly_sales.vue?vue&type=template&id=a3bc20e2&scoped=true&"
import script from "./customer_monthly_sales.vue?vue&type=script&lang=js&"
export * from "./customer_monthly_sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bc20e2",
  null
  
)

export default component.exports